import React from 'react';
import Script from "react-load-script";
import SupportLink from '../../styled-components/SupportLink';

class Support extends React.Component {
  constructor() {
    super()
    this.state = {w: {}, isFetching: true}
  }
  handleScriptLoad() {
    const localStorageAllowCookies = localStorage.getItem('allowCookies-' + 'GTM-TJDFWH')

    if(localStorageAllowCookies) {
      const timer = () => {
        if(!window.zE) {
          return console.log('waiting...')
        }
        this.setState({window: zE, isFetching: false})
      }

      var myVar = setInterval(() => {
        timer();
      }, 300);  
    }
  }
  render() {
    return (
      <SupportLink>
        { !this.state.isFetching ? <p onClick={() => this.state.window.activate()}>Support</p> : <p>Loading Support...</p> }
        <Script
          url="https://visotv.netlify.com/img/Zendex.js"
          onLoad={() => this.handleScriptLoad()}
        />
      </SupportLink>
    )
  }
}

export default Support;



// WEBPACK FOOTER //
// ./src/components/Support/index.js